document.querySelectorAll('[data-custom-personalization][data-mode="image"]').forEach(function (root) {
  var fileInput = root.querySelector('[data-custom-image-input]');
  var cropChip = root.querySelector('[data-open-crop]');
  var cropStage = document.querySelector('[data-crop-stage]');
  var cropImage = document.querySelector('[data-crop-image]');
  var cropBox = document.querySelector('[data-crop-box]');
  var cropConfirm = document.querySelector('[data-crop-confirm]');

  if (!fileInput || !cropChip || !cropStage || !cropImage || !cropBox || !cropConfirm) return;

  var sourceFile = null;
  var sourceObjectUrl = null;
  var box = { x: 0, y: 0, width: 0, height: 0 };
  var MIN_BOX_SIZE = 40;

  fileInput.addEventListener('change', function () {
    var file = fileInput.files && fileInput.files[0];
    cropChip.hidden = !file;
    if (file) sourceFile = file;
  });

  function initCropBox() {
    var w = cropImage.clientWidth;
    var h = cropImage.clientHeight;
    var size = Math.min(w, h) * 0.8;
    box.width = size;
    box.height = size;
    box.x = (w - size) / 2;
    box.y = (h - size) / 2;
    applyBox();
  }

  function applyBox() {
    cropBox.style.left = box.x + 'px';
    cropBox.style.top = box.y + 'px';
    cropBox.style.width = box.width + 'px';
    cropBox.style.height = box.height + 'px';
  }

  function clampBox() {
    var w = cropImage.clientWidth;
    var h = cropImage.clientHeight;
    box.width = Math.min(box.width, w);
    box.height = Math.min(box.height, h);
    box.x = Math.max(0, Math.min(box.x, w - box.width));
    box.y = Math.max(0, Math.min(box.y, h - box.height));
  }

  cropChip.addEventListener('click', function () {
    if (!sourceFile) return;
    if (sourceObjectUrl) URL.revokeObjectURL(sourceObjectUrl);
    sourceObjectUrl = URL.createObjectURL(sourceFile);
    cropImage.onload = initCropBox;
    cropImage.src = sourceObjectUrl;
  });

  // Dragging the box itself moves it; dragging a handle resizes from that corner.
  function startDrag(evt, mode, handle) {
    evt.preventDefault();
    var startX = evt.clientX;
    var startY = evt.clientY;
    var startBox = { x: box.x, y: box.y, width: box.width, height: box.height };
    var stageW = cropImage.clientWidth;
    var stageH = cropImage.clientHeight;

    function onMove(moveEvt) {
      var dx = moveEvt.clientX - startX;
      var dy = moveEvt.clientY - startY;

      if (mode === 'move') {
        box.x = Math.max(0, Math.min(startBox.x + dx, stageW - startBox.width));
        box.y = Math.max(0, Math.min(startBox.y + dy, stageH - startBox.height));
      } else {
        var left = startBox.x;
        var top = startBox.y;
        var right = startBox.x + startBox.width;
        var bottom = startBox.y + startBox.height;

        if (handle === 'nw' || handle === 'sw') left = Math.min(startBox.x + dx, right - MIN_BOX_SIZE);
        if (handle === 'ne' || handle === 'se') right = Math.max(startBox.x + startBox.width + dx, left + MIN_BOX_SIZE);
        if (handle === 'nw' || handle === 'ne') top = Math.min(startBox.y + dy, bottom - MIN_BOX_SIZE);
        if (handle === 'sw' || handle === 'se') bottom = Math.max(startBox.y + startBox.height + dy, top + MIN_BOX_SIZE);

        left = Math.max(0, left);
        top = Math.max(0, top);
        right = Math.min(stageW, right);
        bottom = Math.min(stageH, bottom);

        box.x = left;
        box.y = top;
        box.width = right - left;
        box.height = bottom - top;
      }

      applyBox();
    }

    function onUp() {
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', onUp);
    }

    document.addEventListener('pointermove', onMove);
    document.addEventListener('pointerup', onUp);
  }

  cropBox.addEventListener('pointerdown', function (evt) {
    if (evt.target.hasAttribute('data-crop-handle')) return;
    startDrag(evt, 'move', null);
  });

  cropBox.querySelectorAll('[data-crop-handle]').forEach(function (handleEl) {
    handleEl.addEventListener('pointerdown', function (evt) {
      evt.stopPropagation();
      startDrag(evt, 'resize', handleEl.getAttribute('data-crop-handle'));
    });
  });

  window.addEventListener('resize', function () {
    if (cropImage.clientWidth) {
      clampBox();
      applyBox();
    }
  });

  cropConfirm.addEventListener('click', function () {
    if (!sourceFile || !cropImage.clientWidth) return;

    var scaleX = cropImage.naturalWidth / cropImage.clientWidth;
    var scaleY = cropImage.naturalHeight / cropImage.clientHeight;

    var canvas = document.createElement('canvas');
    canvas.width = Math.round(box.width * scaleX);
    canvas.height = Math.round(box.height * scaleY);
    var ctx = canvas.getContext('2d');
    ctx.drawImage(
      cropImage,
      box.x * scaleX,
      box.y * scaleY,
      box.width * scaleX,
      box.height * scaleY,
      0,
      0,
      canvas.width,
      canvas.height
    );

    var outputType = sourceFile.type === 'image/jpeg' ? 'image/jpeg' : 'image/png';
    canvas.toBlob(
      function (blob) {
        if (!blob) return;
        var croppedFile = new File([blob], sourceFile.name, { type: outputType });
        var dataTransfer = new DataTransfer();
        dataTransfer.items.add(croppedFile);
        fileInput.files = dataTransfer.files;
        fileInput.dispatchEvent(new Event('change', { bubbles: true }));

        var modal = cropStage.closest('modal-dialog');
        if (modal && typeof modal.hide === 'function') modal.hide();
      },
      outputType,
      0.92
    );
  });
});
